var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardKableGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 16.5C6.16421 16.5 6.5 16.8358 6.5 17.25C6.5 17.6642 6.16421 18 5.75 18C5.33579 18 5 17.6642 5 17.25C5 16.8358 5.33579 16.5 5.75 16.5ZM18.25 16.5C18.6642 16.5 19 16.8358 19 17.25C19 17.6642 18.6642 18 18.25 18C17.8359 17.9999 17.5 17.6641 17.5 17.25C17.5 16.8359 17.8359 16.5001 18.25 16.5ZM5.75 12C6.16421 12 6.5 12.3358 6.5 12.75C6.5 13.1642 6.16421 13.5 5.75 13.5C5.33579 13.5 5 13.1642 5 12.75C5 12.3358 5.33579 12 5.75 12ZM9.75 12C10.1642 12 10.5 12.3358 10.5 12.75C10.5 13.1642 10.1642 13.5 9.75 13.5C9.33579 13.5 9 13.1642 9 12.75C9 12.3358 9.33579 12 9.75 12ZM14.25 12C14.6642 12 15 12.3358 15 12.75C15 13.1642 14.6642 13.5 14.25 13.5C13.8358 13.5 13.5 13.1642 13.5 12.75C13.5 12.3358 13.8358 12 14.25 12ZM18.25 12C18.6642 12 19 12.3358 19 12.75C19 13.1642 18.6642 13.5 18.25 13.5C17.8359 13.4999 17.5 13.1641 17.5 12.75C17.5 12.3359 17.8359 12.0001 18.25 12Z",
    fill: "currentColor",
    fillOpacity: 0.5,
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.25H14.25M5.75 8.75V7.25C5.75 5.86929 6.86929 4.75 8.25 4.75H16.75C17.5784 4.75 18.25 4.07843 18.25 3.25V2.75M4.75 8.75H19.25C20.9069 8.75 22.25 10.0931 22.25 11.75V18.25C22.25 19.9069 20.9069 21.25 19.25 21.25H4.75C3.09315 21.25 1.75 19.9069 1.75 18.25V11.75C1.75 10.0931 3.09315 8.75 4.75 8.75Z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardKableGray);
export default __webpack_public_path__ + "static/media/keyboard_kable_gray.1f874c2f71eef06a671db114c774bf76.svg";
export { ForwardRef as ReactComponent };